export const defaultTheme = {
  colors: {
    primary: "#F6A31C",
    secondary: "#FEF6E8",
    blue500: "#171F41",
    blue900: "#0A0D1B",
    lightBlue: "#4A537D",
    blackAlmost: "#020010",
    yellow: "#FCE2B9",
    background: "#f0f2f5",
    grey100: "#FCFCFC",
    grey: "#606060",
    lightGrey: "#7D7D7D",
    facebook: "#1877F2",
    white: "#fff",
    text: "#000",
    border: "#EDEDED",
    error: "#ff4d4f",
  },
  gradients: {
    darkBlue: "linear-gradient(180deg, #020010 6.73%, #171F41 93.27%)",
    orange: "linear-gradient(180deg, #DD8B07 0%, #F6A31C 100%)",
  },
  borderRadius: "8px",
  fontSize: "16px",
};
